import '../../styles/templates/pages/page.benefits-grid.scss';
import { loyaltyInit } from '../utils/loyalty-helpers';
import { resizeObserver } from '../utils/helpers';
import './product/components/AccessBenefitsGrid';

const isDomesticPage = window.location.pathname.includes('pages/access');
loyaltyInit(isDomesticPage);

window.addEventListener('DOMContentLoaded', () => {
  var loyaltyInsightsWebview = document.querySelector('.loyalty-insights-webview');
  if (loyaltyInsightsWebview) resizeObserver.observe(loyaltyInsightsWebview);
});
